import _ from 'lodash';

function toFixedFix(n, prec) {
  const k = 10 ** prec;
  return `${Math.ceil(n * k) / k}`;
}
/**
 *
 * @param {*} data 时间
 * @param {*} format 格式化字符
 */
export function dateFormat(data, format) {
  return window.dayjs(data).format(format);
}

/**
 * @description 格式化金额
 * @param number：要格式化的数字
 * @param decimals：保留几位小数 默认0位
 * @param decPoint：小数点符号 默认.
 * @param thousandsSep：千分位符号 默认为,
 */
export function formatMoney(number, decimals = 2, decPoint = '.', thousandsSep = ',') {
  const tmpNumber = (`${number}`).replace(/[^0-9+-Ee.]/g, '');
  const n = !_.isFinite(+tmpNumber) ? 0 : +tmpNumber;
  const prec = !_.isFinite(+decimals) ? 0 : Math.abs(decimals);
  const sep = (typeof thousandsSep === 'undefined') ? ',' : thousandsSep;
  const dec = (typeof decPoint === 'undefined') ? '.' : decPoint;
  let s = '';
  s = (prec ? toFixedFix(n, prec) : `${Math.round(n)}`).split('.');
  const re = /(-?\d+)(\d{3})/;
  while (re.test(s[0])) {
    s[0] = s[0].replace(re, `$1${sep}$2`);
  }
  if ((s[1] || '').length < prec) {
    s[1] = s[1] || '';
    s[1] += new Array(prec - s[1].length + 1).join('0');
  }
  return s.join(dec);
}

/* *
 * 价格 100---》100.00  0.2--->0.20
 */
export function formattedPrice(item) {
  if (item) {
    const parseF = parseFloat(item);
    if (_.isNaN(parseF)) {
      return 0.00;
    }
    // 金额转化为份，在取整
    const toPoints = Math.round(item * 100) / 100;
    let toStr = toPoints.toString();
    let retStr = toStr.indexOf('.');
    if (retStr < 0) {
      retStr = toStr.length;
      toStr += '.';
    }
    while (toStr.length <= retStr + 2) {
      toStr += '0';
    }
    return toStr;
  }
  return '';
}
